
export default {
  path: 'qr',
  name: 'admin.event.qr',
  component: () => import(/* webpackChunkName: "admin" */ 'client/admin/event/qr/wrapper.vue'),
};
